import plateImgL from '../images/Parallax2_L.webp'
import plateImgS from '../images/Parallax2_S.webp'
import { PlateContainer } from './styled'
const Plate = () => {
  return (
    <PlateContainer>
      <picture>
        <source
          srcSet={plateImgS}
          media="(max-width: 1024px)"
          type="image/webp"
        />
        <img src={plateImgL} alt="car" />
      </picture>
    </PlateContainer>
  )
}
export default Plate
